import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewEncapsulation } from '@angular/core';
import { TessContext } from '../shared/tess-context/tess-context';
import { AppHost } from 'lib-host-interface';
import { LoggingService } from '../shared/services/logging.service';
import { ApphostService } from '../shared/services/app-host.service';
import { QuickLink } from '../shared/models/quick-links';
import { LandingService } from './landing.service';

@Component({
  selector: 'tess-landing',
  templateUrl: './landing.component.html',
  styleUrls: ['./landing.component.scss'],
  encapsulation: ViewEncapsulation.ShadowDom,
})
export class LandingComponent extends TessContext implements OnInit {
  quickLinks: QuickLink[] = [];
  dashboardTitle: string = 'Loading...';
  entitlements: string[];
  showBanner: boolean = true;
  private readonly BANNER_STORAGE_KEY = 'tess-banner-closed';

  constructor(
    appHost: AppHost,
    changeDetectorRef: ChangeDetectorRef,
    elementRef: ElementRef,
    private apphostService: ApphostService,
    loggingService: LoggingService,
    private landingService: LandingService,
  ) {
    super(appHost, changeDetectorRef, elementRef, apphostService, loggingService);
  }

  async ngOnInit() {
    await this.initiateTessApp();
    this.entitlements = this.apphostService.getUserEntitlements();
    this.loggingService.log(`User entitlements: ${JSON.stringify(this.entitlements)}`);
    this.initializeBannerState();
    this.refreshContent();
    this.loggingService.log('app-tess Landing Component initialized');

  }

  public refreshContent() {
    this.quickLinks = this.landingService.createQuickLinksFromEntitlements(this.entitlements);
    this.dashboardTitle = this.landingService.getDashboardTitle(this.entitlements);
    this.changeDetectorRef.detectChanges();
  }

  public closeBanner() {
    this.showBanner = false;
    this.setBannerClosedInStorage();
  }

  private initializeBannerState(): void {
    try {
      const bannerClosed = sessionStorage.getItem(this.BANNER_STORAGE_KEY);
      this.showBanner = bannerClosed !== 'true';
    } catch (error) {
      // Fallback for environments where sessionStorage is not available (e.g., tests)
      this.showBanner = true;
      this.loggingService.log('SessionStorage not available, using default banner state');
    }
  }

  private setBannerClosedInStorage(): void {
    try {
      sessionStorage.setItem(this.BANNER_STORAGE_KEY, 'true');
    } catch (error) {
      // Silently handle sessionStorage errors
      this.loggingService.log('Could not save banner state to sessionStorage');
    }
  }

  isExamPath(): boolean {
    const url = window.location.href;
    return url.includes('/tess/exams');
  }
}
